import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import type { RoleKey } from '../mockup-data';
import { RoleAuthorizationService } from './role-authorization.service';

function requireRole(requiredRole: RoleKey): CanActivateFn {
  return (_route, state) => {
    const authorization = inject(RoleAuthorizationService);
    const router = inject(Router);

    if (authorization.hasRole(requiredRole)) {
      return true;
    }

    return router.createUrlTree(['/unauthorized'], {
      queryParams: { from: state.url },
    });
  };
}

export const userRoleGuard = requireRole('user');
export const approverRoleGuard = requireRole('approver');
export const adminRoleGuard = requireRole('admin');

/**
 * Sends an authenticated user to the highest-priority dashboard represented in
 * the JWT roles array: admin -> approver -> user.
 */
export const roleLandingGuard: CanActivateFn = () => {
  const authorization = inject(RoleAuthorizationService);
  const router = inject(Router);
  const role = authorization.defaultRole();

  return role
    ? router.createUrlTree([`/${role}/dashboard`])
    : router.createUrlTree(['/unauthorized']);
};
